import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'

interface Props {
  description: string | null
  offeredServiceDescriptionPlainText: string | null
  placeholder: string
  onChange: (description: string | null) => void
  rows?: number
  className?: string
}

const i18nScoped = new I18nService(require('./quotation-description-input.component.yml'))

export default function QuotationDescriptionInputComponent ({ description, offeredServiceDescriptionPlainText, placeholder, onChange, rows = 2, className }: Props) {
  return <div className={ ['u-positionRelative', className].filter(Boolean).join(' ') }>
    { !description && offeredServiceDescriptionPlainText && <div className="u-positionAbsolute" style={{ top: '0.875em', right: '0.875em' }}>
      <a onClick={ () => onChange(offeredServiceDescriptionPlainText.trim()) }>
        { i18nScoped.t('use_offered_service_description') }
      </a>
    </div> }

    <textarea
      style={{ width: '100%' }}
      className='u-mts'
      rows={ rows }
      placeholder={ placeholder }
      value={ description ?? '' }
      onChange={ evt => onChange(evt.target.value || null) } />
  </div>
}